import { apiAuthClient } from 'shared/api/lib';

import type { GetAuthHintRequestType, GetAuthHintResponseType } from '../types';

export const getAuthHint = async ({
  pathParams: { hintToken },
}: GetAuthHintRequestType) => {
  const url = `/api/v2/auth/hint?token=${hintToken}`;

  const { data } = await apiAuthClient.get<GetAuthHintResponseType>(url);

  return data.data;
};
